import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { Divider, Button } from 'semantic-ui-react'
import Moment from 'react-moment'

import { StdCard } from 'components'
import { Cont, ContDetail} from './styled'

const CommentComponent = (props) => {

  const { 
    valueForm,
    // props
  } = props

  return (
    <StdCard title={<span className='stepTitle'>Comment</span>}>
      <Cont>
        {valueForm.comments.map((data)=>{
          return(
            <Cont>
              <ContDetail>
                <div>Commented by : </div>
                <div>{data.createdByName}</div>
              </ContDetail>
              <ContDetail>
                <div>Commented date : </div>
                <div><Moment format="DD MMM YYYY HH:mm">{data.createdDate}</Moment></div>
              </ContDetail>
              <ContDetail>
                <div>Activity : </div>
                <div>{data.activity}</div>
              </ContDetail>
              <ContDetail>
                <div>Action : </div>
                <div>{data.action}</div>
              </ContDetail>
              <ContDetail>
                <div>Comment : </div>
                <div>{data.comment || '-'}</div>
              </ContDetail>
              <ContDetail>
                <div>Attachment : </div>
                <div className='fileList'>
                  {
                    valueForm.attachments.map((item) => {
                      if(data.id == item.commentId){
                        return (
                          <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={() => (window.open(item.urlPath, "_blank"))} />
                        )
                      }else{
                        return null
                      }
                    })
                  }
                </div>
              </ContDetail>
              <Divider />
            </Cont>
          )
        })}
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompany')(state) || {comments:[]},
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentComponent)
